export const styles = {
  targetTypeContainer: {
    display: 'flex',
    gap: 24,
    alignItems: 'center',
  },
  label: {
    margin: 0,
  },
  radioButtonWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  rowMarginTop16: {
    marginTop: 16,
  },
  rowMarginTop16Flex: {
    marginTop: 16,
    alignItems: 'center',
    display: 'flex',
  },
  rowMarginTop8: {
    marginTop: 8,
  },
}
